/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { ModelUtils } from '../util/ModelUtils';
import { Document } from '../../core/models/Document';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SecurityScheme } from '../../openapi/v3/models/Oas30SecurityScheme';
import { DeleteSecuritySchemeCommand } from './DeleteSecuritySchemeCommand';

/**
 * @author eric.wittmann@gmail.com
 * @extends DeleteSecuritySchemeCommand
 * @class
 */
export class DeleteSecuritySchemeCommand_30 extends DeleteSecuritySchemeCommand {
    public constructor(schemeName? : any) {
        if(((typeof schemeName === 'string') || schemeName === null)) {
            let __args = arguments;
            super(schemeName);
        } else if(schemeName === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand#doDeleteScheme(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     * @return {*}
     */
    doDeleteScheme(document : Document) : any {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components)) {
            return Library.writeNode(doc30.components.removeSecurityScheme(this._schemeName));
        } else {
            return null;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand#doRestoreScheme(io.apicurio.datamodels.core.models.Document, java.lang.Object)
     * @param {Document} document
     * @param {*} oldScheme
     */
    doRestoreScheme(document : Document, oldScheme : any) {
        let doc30 : Oas30Document = <Oas30Document>document;
        if(ModelUtils.isDefined(doc30.components)) {
            let scheme : Oas30SecurityScheme = doc30.components.createSecurityScheme(this._schemeName);
            Library.readNode(oldScheme, scheme);
            doc30.components.addSecurityScheme(this._schemeName, scheme);
        }
    }
}
DeleteSecuritySchemeCommand_30["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteSecuritySchemeCommand_30";
DeleteSecuritySchemeCommand_30["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




